import type { SubmissionPresentationManifest } from "../../../shared/submission-document";
import type { IntakeStep } from "../types";

export function createSubmissionPresentationManifest(steps: IntakeStep[]): SubmissionPresentationManifest {
  return {
    version: 1,
    sections: steps
      .filter((step) => (step.fields?.length ?? 0) > 0 || (step.repeaters?.length ?? 0) > 0 || (step.fileUploads?.length ?? 0) > 0)
      .map((step) => ({
        id: step.id,
        title: step.title,
        fields: (step.fields ?? []).map((field) => ({
          path: field.path,
          label: field.label,
          type: field.type,
          ...(field.options?.length ? { options: field.options.map((option) => ({ value: option.value, label: option.label })) } : {}),
        })),
        repeaters: (step.repeaters ?? []).map((repeater) => ({
          path: repeater.path,
          label: repeater.label,
          fields: repeater.fields.map((field) => ({
            path: field.path,
            label: field.label,
            type: field.type,
            ...(field.options?.length ? { options: field.options.map((option) => ({ value: option.value, label: option.label })) } : {}),
          })),
        })),
        uploads: (step.fileUploads ?? []).map((upload) => ({ id: upload.id, category: upload.category, label: upload.label })),
      })),
  };
}
